import { render, staticRenderFns } from "./QuoteListSideMenu.vue?vue&type=template&id=20be5a13"
import script from "./QuoteListSideMenu.vue?vue&type=script&lang=js"
export * from "./QuoteListSideMenu.vue?vue&type=script&lang=js"
import style1 from "./QuoteListSideMenu.vue?vue&type=style&index=1&id=20be5a13&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20be5a13')) {
      api.createRecord('20be5a13', component.options)
    } else {
      api.reload('20be5a13', component.options)
    }
    module.hot.accept("./QuoteListSideMenu.vue?vue&type=template&id=20be5a13", function () {
      api.rerender('20be5a13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteListSideMenu.vue"
export default component.exports